module.exports = __webpack_public_path__ + "img/hrm-raymond-lg.aa0304c.png";